import { Injectable } from "@angular/core";
import axios, { AxiosRequestConfig } from "axios";
import parsePhoneNumber from 'libphonenumber-js';

@Injectable({
  providedIn: "root",
})
export class SmsService {

  constructor() {  }

  enviar(numero: string, texto: string) {
    if (numero.length > 9) {
      var phoneNumber = parsePhoneNumber(numero);
      if (phoneNumber == undefined) {
        phoneNumber = parsePhoneNumber(numero, 'VE');
        if (phoneNumber != undefined) {
          if (phoneNumber.number.length > 10) {
            var telefono = phoneNumber.number.replace("+", "");
            var chatId = telefono + "@c.us";
            var mensaje = {
              "chatId": chatId,
              "content": texto,
              "contentType": "string",
              "options": {}
            }
            this.whatsapp(mensaje);
          }
        }
      } else {
        var telefono = phoneNumber.number.replace("+", "");
        var chatId = telefono + "@c.us";
        var mensaje = {
          "chatId": chatId,
          "content": texto,
          "contentType": "string",
          "options": {}
        }
        this.whatsapp(mensaje);
      }
    }
  }


  
  whatsapp(mensaje: any) {
  
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'https://rbcodehouse.duckdns.org:3000/client/sendMessage/CASA',
      headers: { 
        'Content-Type': 'application/json', 
        'x-api-key': '24674967-24674966-6404900-8746843'
      },
      data : mensaje
    };
    
    axios.request(config)
    .then((response) => {
      console.log(JSON.stringify(response.data));
    })
    .catch((error) => {
      console.log(error);
    });
  }
}
